import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RunAISummarizeLogEventsVariables = Types.Exact<{
  input: Types.AISummarizeLogEventsInput;
}>;

export type RunAISummarizeLogEvents = {
  aiSummarizeLogEvents: Pick<
    Types.AIInferenceStream,
    'streamName' | 'streamId' | 'pinned' | 'private' | 'saved' | 'createdAt' | 'parentStreamId'
  > & { createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser> };
};

export const RunAISummarizeLogEventsDocument = gql`
  mutation RunAISummarizeLogEvents($input: AISummarizeLogEventsInput!) {
    aiSummarizeLogEvents(input: $input) {
      streamName
      streamId
      pinned
      private
      saved
      createdBy {
        ...ActorTeaser
      }
      createdAt
      parentStreamId
    }
  }
  ${ActorTeaser}
`;
export type RunAISummarizeLogEventsMutationFn = Apollo.MutationFunction<
  RunAISummarizeLogEvents,
  RunAISummarizeLogEventsVariables
>;

/**
 * __useRunAISummarizeLogEvents__
 *
 * To run a mutation, you first call `useRunAISummarizeLogEvents` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAISummarizeLogEvents` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAiSummarizeLogEvents, { data, loading, error }] = useRunAISummarizeLogEvents({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunAISummarizeLogEvents(
  baseOptions?: Apollo.MutationHookOptions<
    RunAISummarizeLogEvents,
    RunAISummarizeLogEventsVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RunAISummarizeLogEvents, RunAISummarizeLogEventsVariables>(
    RunAISummarizeLogEventsDocument,
    options,
  );
}
export type RunAISummarizeLogEventsHookResult = ReturnType<typeof useRunAISummarizeLogEvents>;
export type RunAISummarizeLogEventsMutationResult = Apollo.MutationResult<RunAISummarizeLogEvents>;
export type RunAISummarizeLogEventsMutationOptions = Apollo.BaseMutationOptions<
  RunAISummarizeLogEvents,
  RunAISummarizeLogEventsVariables
>;
export function mockRunAISummarizeLogEvents({
  data,
  variables,
  errors,
}: {
  data: RunAISummarizeLogEvents;
  variables?: RunAISummarizeLogEventsVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: RunAISummarizeLogEventsDocument, variables },
    result: { data, errors },
  };
}
